// src/main.jsx
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import { ThemeProvider } from './context/ThemeContext';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ClinicProvider } from './context/ClinicContext';

const StrictWrapper = ({ children }) => {
  const ENABLE = import.meta.env.VITE_ENABLE_STRICT === 'true';
  return ENABLE ? <StrictMode>{children}</StrictMode> : children;
};

createRoot(document.getElementById('root')).render(
  <StrictWrapper>
    <ThemeProvider>
      <CssBaseline />
      <AuthProvider>
        <ClinicProvider>
         <BrowserRouter>
          <App />
         </BrowserRouter>
        </ClinicProvider>
      </AuthProvider>
    </ThemeProvider>
  </StrictWrapper>
);
